var l={MIN:1,MAX:2.5,STEP:1.5},a="gestures-layout",e="@hpstellar/pdp/gallery-modal";export{a as GESTURES_LAYOUT,l as ZOOM_LEVEL,e as galleryModalTestId};
